import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import * as React from 'react';
// import { OutboundLink } from 'react-ga';

interface IProps {
  sponsorUrl?: string;
}

export const SponsorUrl = ({ sponsorUrl, children }: React.PropsWithChildren<IProps>) => {
  if (sponsorUrl) {
    return (
      <LinkFactoryReactRouter href={sponsorUrl} className="Link u-linkClean" target="_blank" rel="noopener noreferrer">
        {children}
      </LinkFactoryReactRouter>
    );
  }

  return <>{children}</>;
};
